import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { AuthModuleComponent } from './auth-module.component';
import { LoginComponent } from './login/login.component';

const routes: Routes = [
  {
    path:'',
    component: AuthModuleComponent,
  }
]

@NgModule({
  declarations: [AuthModuleComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
  ]
})
export class AuthModuleModule { }
